import React, { useState, useEffect, useCallback } from "react";
import { AlertCircle } from "lucide-react";
import { API_CONFIG, getHeaders, refreshAccessToken } from "../../config/api";
import { Truck } from "lucide-react";
import { useAuth } from "../../context/AuthContext"; // Auth context

export default function Dutypendingtopayinexbondreport() {
    const [pendingDutyExbondData, setPendingDutyExbondData] = useState({
        total_weight: 0,
        total_duty: 0,
        total_exbond_count: 0
    });
    const [pendingDutyDispatchData, setPendingDutyDispatchData] = useState({
        dispatch_count: 0,
        pending_dispatch_weight: 0
    })
    const { logout } = useAuth();


    // Fetch PENDING DUTY DATA for first heading
    const fetchPendingExbondDuty = useCallback(async () => {
        let url = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.REPORTS.GET_DUTY_PENDING_EXBOND}`;

        try {
            let response = await fetch(url, { method: "GET", headers: getHeaders(true) });

            // -------------------------
            // 🔥 Handle 401 token expired
            // -------------------------
            if (response.status === 401) {
                console.warn("Access token expired. Attempting refresh...");
                const newToken = await refreshAccessToken();

                if (newToken) {
                    // Retry the same API call with new token
                    response = await fetch(url, { method: "GET", headers: getHeaders(true) });
                } else {
                    console.error("Refresh token failed. Logging out...");
                    logout(); // redirect user
                    return;
                }
            }


            const result = await response.json();

            if (result.status === 200) {
                setPendingDutyExbondData(result.data);
            }
        } catch (error) {
            console.error(error);
        }
    }, [logout]);
    const fetchPendingDispatchDuty = useCallback(async () => {
        let url = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.REPORTS.GET_DUTY_PAID_PENDING_DISPATCH}`;

        try {
            let response = await fetch(url, { method: "GET", headers: getHeaders(true) });

            // -------------------------
            // 🔥 Handle 401 token expired
            // -------------------------
            if (response.status === 401) {
                console.warn("Access token expired. Attempting refresh...");
                const newToken = await refreshAccessToken();

                if (newToken) {
                    // Retry the same API call with new token
                    response = await fetch(url, { method: "GET", headers: getHeaders(true) });
                } else {
                    console.error("Refresh token failed. Logging out...");
                    logout(); // redirect user
                    return;
                }
            }

            const result = await response.json();

            if (result.status === 200) {
                setPendingDutyDispatchData(result.data);
            }
        } catch (error) {
            console.error(error);
        }
    }, [logout]);

    // Load report and summary on first render
    useEffect(() => {
        fetchPendingExbondDuty();
        fetchPendingDispatchDuty();
    }, [fetchPendingExbondDuty, fetchPendingDispatchDuty]);

    const formatIndianNumber = (num) => {
        if (num === null || num === undefined || isNaN(num)) return "0";
        return Number(num).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    return (
        <div className="w-full xl:w-1/2 bg-white p-6 rounded border border-gray-100 shadow-sm hover:shadow-md transition-shadow">

            {/* ===================== MAIN HEADING ===================== */}
            <div className="flex items-center justify-between border-b border-dashed pb-3 mb-5">
                <div className="flex items-center gap-2">
                    <AlertCircle className="text-indigo-500" size={20} />
                    <h2 className="text-base font-semibold text-gray-900">
                        Duty Pending to Pay in Exbond
                    </h2>
                </div>
            </div>

            {/* ===================== 3 CARDS ROW 1 (dynamic) ===================== */}
            <div className="grid grid-cols-3 gap-4 mb-6">
                <div className="p-4 rounded text-center shadow-sm border border-gray-200">
                    <p className="text-xs text-gray-600">Total Exbond</p>
                    <p className="text-xl font-bold text-gray-700">{pendingDutyExbondData.total_exbond_count}</p>
                </div>

                <div className="p-4 rounded text-center shadow-sm border border-gray-200">
                    <p className="text-xs text-gray-600">Total Duty</p>
                    <p className="text-xl font-bold text-gray-700">{formatIndianNumber(pendingDutyExbondData.total_duty)}</p>
                </div>

                <div className="p-4 rounded text-center shadow-sm border border-gray-200">
                    <p className="text-xs text-gray-600">Total Weight</p>
                    <p className="text-xl font-bold text-gray-700">{formatIndianNumber(pendingDutyExbondData.total_weight)}</p>
                </div>
            </div>

            {/* ===================== SECOND HEADING ===================== */}
            <div className="flex items-center gap-2 mb-3 border-b border-dashed pb-2">
                <Truck className="text-indigo-500" size={18} />
                <h2 className="text-base font-semibold text-gray-900">
                    Duty Paid but Pending Dispatch
                </h2>
            </div>

            {/* ===================== 3 CARDS ROW 2 (centered) ===================== */}
            <div className="grid grid-cols-3 gap-4">
                <div className="p-4 rounded text-center shadow-sm border border-gray-200">
                    <p className="text-xs text-gray-600">Total Duty</p>
                    <p className="text-xl font-bold text-gray-700">{pendingDutyDispatchData.duty_paid_pending_dispatch_count}</p>
                </div>
                <div className="p-4 rounded text-center shadow-sm border border-gray-200">
                    <p className="text-xs text-gray-600">Total Weight</p>
                    <p className="text-xl font-bold text-gray-700">{formatIndianNumber(pendingDutyDispatchData.pending_dispatch_weight)}</p>
                </div>
            </div>

        </div>
    );
}
